import { SystemField } from "./system-field";

export class Recordtype extends SystemField {
     
     object_name?:string;
     name?:string;
     label?:string;
}

export class PublicRecordtype extends Recordtype{}